import React, { useEffect, useState } from "react";
import api, { API_URL } from "../lib/api";

const LOGO_WHITE = "/logo-white.png";
export const DEFAULT_PANEL = {
  color: "#003A70",
  photo_url: "/signin/building.jpg",
  headline: "Your captive. Clearly measured.",
  description:
    "Track Experience Rated Refunds, submit vendor invoices, and understand the medical " +
    "condition prevalence of your covered population — all in one authenticated workspace.",
};
const PANEL_EVENT = "signin-panel-updated";
let cached = null;

export const resolvePhotoUrl = (url) =>
  url && url.startsWith("/api/") ? `${API_URL}${url.slice(4)}` : url;

const rgba = (hex, alpha) => {
  const n = parseInt(hex.replace("#", ""), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`;
};

export const publishPanel = (panel) => {
  cached = Promise.resolve(panel);
  window.dispatchEvent(new CustomEvent(PANEL_EVENT, { detail: panel }));
};

function useSigninPanel() {
  const [panel, setPanel] = useState(DEFAULT_PANEL);
  useEffect(() => {
    if (!cached) cached = api.get("/public/signin-panel").then(({ data }) => data).catch(() => DEFAULT_PANEL);
    let live = true;
    cached.then((data) => { if (live) setPanel(data); });
    const onUpdate = (event) => setPanel(event.detail);
    window.addEventListener(PANEL_EVENT, onUpdate);
    return () => { live = false; window.removeEventListener(PANEL_EVENT, onUpdate); };
  }, []);
  return panel;
}

export function PanelBackdrop({ panel }) {
  return (
    <>
      {panel.photo_url && (
        <div className="absolute inset-0" style={{
          backgroundImage: `url(${resolvePhotoUrl(panel.photo_url)})`, backgroundSize: "cover",
          backgroundPosition: "center", filter: "grayscale(0.4) contrast(1.1)", opacity: 0.7,
        }} />
      )}
      <div className="absolute inset-0" style={{
        background: `linear-gradient(180deg, ${rgba(panel.color, 0.9)} 0%, ${rgba(panel.color, 0.96)} 100%)`,
      }} />
    </>
  );
}

export function AuthHeroPanel({ eyebrow = "Client access · Encrypted", footer, testId, logoTestId, className = "", children }) {
  const panel = useSigninPanel();
  return (
    <aside className={`relative hidden overflow-hidden lg:col-span-2 lg:block ${className}`}
           style={{ background: panel.color }} data-testid={testId} data-panel-color={panel.color}>
      <PanelBackdrop panel={panel} />
      <div className="relative flex h-full flex-col justify-between p-12 text-[#F7F7F6] xl:p-16">
        <img src={LOGO_WHITE} alt="EmployeesFirst" className="h-14 max-w-[300px] w-auto object-contain"
             width="300" height="56" data-testid={logoTestId} />
        <div>
          <div className="eyebrow mb-6" style={{ color: "#BFD6EC" }} data-testid={`${testId}-eyebrow`}>{eyebrow}</div>
          {typeof children === "function" ? children(panel) : children}
        </div>
        <div className="flex items-center gap-3 eyebrow" style={{ color: "#D6E4F2" }}>{footer}</div>
      </div>
    </aside>
  );
}
